import OutrightSeasonMapper from './outright-season-mapper';
import OutrightSeasonModelBase from '../../agent/outright-season/outright-season-model';
import CategoryModel from '../../agent/category/category-model';

const OutrightSeasonModel = {
    ...OutrightSeasonModelBase,

    mapper: OutrightSeasonMapper,

    category: {
        fieldName: 't',
        model: CategoryModel,
        type: Object,
    },

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    names: {
        fieldName: 'n',
        type: Object,
    },

    // season: {
    //     fieldName: 'n',
    //     model: SeasonModel,
    //     modelContext: {
    //         category: 'category',
    //     },
    //     type: Object,
    // },
};

export default OutrightSeasonModel;
